




























import { EnumTenancyType, EnumTenancyTypeMD } from '@/api/com/MetaPattern/APP/MDA/User/EnumTenancyType';
import { User } from '@/api/com/MetaPattern/APP/MDA/User/User';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class AccountInfo extends Vue {
  get user(): User {
    return IDEContext.instance.curUser;
  }

  get account() {
    return IDEContext.instance.curAccountInfo;
  }

  get tenancyName(): string {
    const curUser = IDEContext.instance.curUser;
    let name = EnumTenancyTypeMD.getItemByValue(curUser.tenancy.tenancyType).displayName;
    if (curUser.tenancy.tenancyType === EnumTenancyType.Organization && curUser.isMain) {
      name += '（主用户）';
    }
    return name;
  }
}

